export type UserRole = 'ADMIN' | 'SUPERVISOR' | 'AGENTE';

interface JwtPayload {
  sub?: string;
  email?: string;
  role?: UserRole;
  exp?: number;
}

function decodeBase64Url(input: string): string {
  const normalized = input.replace(/-/g, '+').replace(/_/g, '/');
  const padLength = (4 - (normalized.length % 4)) % 4;
  const padded = normalized + '='.repeat(padLength);
  return atob(padded);
}

export function getCurrentUserRole(): UserRole | null {
  const token = localStorage.getItem('accessToken');
  if (!token) return null;

  const parts = token.split('.');
  if (parts.length < 2) return null;

  try {
    const payloadJson = decodeBase64Url(parts[1]);
    const payload = JSON.parse(payloadJson) as JwtPayload;
    if (payload.role === 'ADMIN' || payload.role === 'SUPERVISOR' || payload.role === 'AGENTE') {
      return payload.role;
    }
  } catch {
    return null;
  }

  return null;
}
